import { PanelRightClose } from 'lucide-react'

interface ScriptPanelProps {
  onClose?: () => void
}

export default function ScriptPanel({ onClose }: ScriptPanelProps) {
  const scriptItems = [
    {
      time: '00:00',
      text: '小明啊，听说你还在那个小公司上班呢？你看看人家隔壁小王，都去硅谷大厂了。2026年了，该考虑考虑跳槽了吧？对象找了没有？你这年纪不小了！',
    },
    {
      time: '00:14',
      text: '新年好啊！工资涨了没有？我听说你们那个行业不太景气啊。要不要考虑考个公务员？稳定！你表哥去年就考上了，现在可滋润了。',
    },
    {
      time: '00:27',
      text: '听你妈说你还单身呢？都快30了吧？人家邻居家小李都二胎了！要不要我给你介绍介绍？我认识一个特别好的，在银行工作，有房有车！',
    },
    {
      time: '00:40',
      text: '新年快乐！买房了没有？现在房价这么高，你可得抓紧啊！你看你堂哥，人家去年全款买了套大平层。你这存款够了吗？要不要家里里支援点？',
    },
  ]

  return (
    <div className="flex w-80 flex-col rounded-xl border border-gray-200 bg-white shadow-sm">
      <div className="flex items-center justify-between border-b border-gray-100 px-4 py-3">
        <h2 className="font-semibold text-gray-900">Audio script</h2>
        <div className="flex items-center gap-2">
          <span className="text-xs font-medium text-gray-500">Caption</span>
          <div className="relative inline-flex h-5 w-9 cursor-pointer items-center rounded-full bg-blue-600 transition-colors">
            <span className="absolute right-1 h-3 w-3 rounded-full bg-white shadow-sm transition-transform" />
          </div>
          <button
            onClick={onClose}
            className="ml-1 rounded p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
          >
            <PanelRightClose className="h-4 w-4 rotate-180" />
          </button>
        </div>
      </div>

      <div className="custom-scrollbar flex-1 overflow-y-auto p-4">
        <div className="space-y-6">
          {scriptItems.map((item, idx) => (
            <div key={idx} className="group flex gap-3">
              <div className="mt-1 shrink-0">
                <span className="rounded-full bg-gray-100 px-2 py-0.5 font-mono text-[10px] font-medium text-gray-500">
                  {item.time}
                </span>
              </div>
              <p className="text-sm leading-relaxed text-gray-600 transition-colors group-hover:text-gray-900">
                {item.text}
              </p>
            </div>
          ))}
          <div className="mt-1">
            <span className="rounded-full bg-gray-100 px-2 py-0.5 font-mono text-[10px] font-medium text-gray-500">
              00:53
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
